module.exports = __webpack_public_path__ + "img/litnisschrofen.dcced1cd.jpg";